import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, LogOut, AlertTriangle, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useBilling } from '../../context/BillingContext';
import OwnerAccountPanel from '../../components/dashboard/OwnerAccountPanel';

// Mirrors content migrated earlier from legacy settings section.
const SettingsTab = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { userActivePlan, userPlanLoading } = useBilling();
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-white">{t('accountSettings.title')}</h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 space-y-6">
          <OwnerAccountPanel plan={userActivePlan} loading={userPlanLoading} />
          <div className="card">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center"><User className="w-5 h-5 mr-2" />{t('accountSettings.personalInfo')}</h3>
            <div className="space-y-4">
              <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.firstName')}</label><input type="text" value={user?.firstName || ''} className="input-field" disabled /></div>
              <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.lastName')}</label><input type="text" value={user?.lastName || ''} className="input-field" disabled /></div>
              <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.email')}</label><input type="email" value={user?.email || ''} className="input-field" disabled /></div>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2 space-y-6">
          <div className="card">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center"><Shield className="w-5 h-5 mr-2" />{t('accountSettings.security')}</h3>
            <div className="space-y-4">
              <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.currentPassword')}</label><input type="password" placeholder={t('accountSettings.enterCurrentPassword')} className="input-field" /></div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.newPassword')}</label><input type="password" placeholder={t('accountSettings.enterNewPassword')} className="input-field" /></div>
                <div><label className="block text-sm font-medium text-gray-300 mb-2">{t('accountSettings.confirmPassword')}</label><input type="password" placeholder={t('accountSettings.confirmNewPassword')} className="input-field" /></div>
              </div>
              <button className="btn-primary w-full">{t('accountSettings.changePassword')}</button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="card">
              <h3 className="text-lg font-semibold text-white mb-4 flex items-center"><LogOut className="w-5 h-5 mr-2" />{t('accountSettings.sessionManagement')}</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between"><span className="text-gray-300">{t('accountSettings.currentSession')}</span><span className="text-green-400 text-sm">{t('accountSettings.active')}</span></div>
                <div className="flex items-center justify-between"><span className="text-gray-300">{t('accountSettings.lastLogin')}</span><span className="text-gray-400 text-sm">{t('accountSettings.unknown')}</span></div>
                <button onClick={logout} className="btn-secondary w-full">{t('accountSettings.logoutAllSessions')}</button>
              </div>
            </div>
            <div className="card border-red-500/50">
              <h3 className="text-lg font-semibold text-red-400 mb-4 flex items-center"><AlertTriangle className="w-5 h-5 mr-2" />{t('accountSettings.dangerZone')}</h3>
              <div className="space-y-4">
                <div className="p-4 bg-red-900/20 border border-red-500/30 rounded-lg">
                  <h4 className="text-red-400 font-semibold mb-2">{t('accountSettings.deleteAccount')}</h4>
                  <p className="text-gray-300 text-sm mb-4">{t('accountSettings.deleteAccountWarning')}</p>
                  <button className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">{t('accountSettings.deleteAccountButton')}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTab;
